import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>("f1");
  const left = faqs.filter((_, index) => index % 2 === 0);
  const right = faqs.filter((_, index) => index % 2 === 1);

  const renderItem = (id: string, q: string, a: string) => {
    const isOpen = openId === id;
    return (
      <div key={id} className="overflow-hidden rounded-lg border border-background-200/70 bg-background-100">
        <h3>
          <button
            type="button"
            aria-expanded={isOpen}
            onClick={() => setOpenId(isOpen ? "" : id)}
            className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
          >
            <span className="text-sm font-semibold text-foreground-950 md:text-base">{q}</span>
            <i
              className={`shrink-0 text-lg transition-transform duration-300 ${
                isOpen ? "ri-subtract-line rotate-180 text-primary-700" : "ri-add-line text-foreground-500"
              }`}
            ></i>
          </button>
        </h3>
        <div
          className={`grid transition-all duration-300 ${
            isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden">
            <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{a}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题：关于片库与使用方式"
          desc="第一次来星辰影视，可能会对片库范围、榜单排序和筛选方式有疑问。下面整理了几个被问得最多的问题。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col gap-4">{left.map((item) => renderItem(item.id, item.q, item.a))}</div>
          <div className="flex flex-col gap-4">{right.map((item) => renderItem(item.id, item.q, item.a))}</div>
        </div>
      </div>
    </section>
  );
}